export default __webpack_public_path__ + "static/media/21.88bcbdb3.webp";